<template>
  <div class="paddingCustom">
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="10" md="8" class="text-center">
        <h4 class="grey--text text--darken-3 font-weight-regular"
          v-html="$t('validate_mobile_content', { mobile: sendingNumber })"></h4>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="10" sm="6" md="4">
        <v-form v-model="isFormValid" @submit.prevent="validateOTP">
          <v-text-field class="mt-3 mb-5" :label="$t('validate_otp_field')" outlined color="primary-1"
            :rules="[inputRules.required, inputRules.validateCode]" v-model="validateCode"
            :error-messages="verifyFail ? $t('validate_otp_invalid') : ''" @input="inputField">
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
          <v-btn depressed block x-large class="nextBtn" :class="{ disabledBtn: !isFormValid || isLoading }"
            :disabled="!isFormValid || isLoading" @click="validateOTP">
            <template v-if="isLoading">
              <v-progress-circular indeterminate color="white" size="25" width="2"></v-progress-circular>
            </template>
            <template v-else>
              {{ $t('next_step') }}
            </template>
          </v-btn>
          <v-btn depressed block x-large color="primary" :style="[timer == 0 ? { border: '3px solid' } : {}]"
            class="mt-5 font-weight-bold" :class="{ disabledBtn: timer !== 0 }"
            :disabled="timer !== 0 || !loadingFinished" :outlined="timer == 0" @click="sendOTP">
            <template v-if="!loadingFinished">
              <v-progress-circular indeterminate color="grey" size="25" width="2"></v-progress-circular>
            </template>
            <template v-else>
              {{ $t('validate_resend_cta') }}
              <template v-if="timer">{{ Math.floor(timer / 60) }}:{{
                (timer % 60).toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                  useGrouping: false
                })
              }}</template>
            </template>
          </v-btn>
        </v-form>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UM from "@/api/user-management";
import inputRulesJS from "@/shared/inputRules.js";

export default {
  data() {
    return {
      isFormValid: false,
      timer: 300,
      validateCode: "",
      inputRules: {
        required: inputRulesJS.required,
        validateCode: value => /^\d{4}$/.test(value) || this.$t('validate_otp_invalid_message')
      },
      verifyFail: false,
      isLoading: false,
      loadingFinished: true
    };
  },
  computed: {
    ...mapGetters({
      formattedNumber: "register/formattedNumber",
      countryCode: "register/countryCode",
      mobile: "register/mobile",
      email: "register/email"
    }),
    sendingNumber() {
      return this.countryCode === '886' ? this.mobile : `+${this.countryCode}${this.mobile}`
    }
  },
  mounted() {
    if (!this.mobile || !this.email) this.$router.push({ name: "Index" }).catch(() => { });
    setInterval(() => {
      if (this.timer) {
        this.timer -= 1;
      }
    }, 1000);
    this.$gtm.trackView(`ValidateMobile`, this.$route.path);
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show"
    }),
    async validateOTP() {
      this.isLoading = true;
      const { data: validateOtpRes } = await UM.validateOTP(
        this.countryCode,
        this.mobile,
        this.validateCode
      );
      this.isLoading = false;

      if (validateOtpRes.errCode === "00") this.$emit("nextStep");
      else this.verifyFail = true;

      return false;
    },
    async sendOTP() {
      this.loadingFinished = false;
      const { data: optRes } = await UM.otp(this.countryCode, this.mobile);
      // console.log(`${String.fromCodePoint(128049)} [UM] otp`, optRes);
      if (optRes.errCode == "00") {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-success@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('validate_otp_send_success')}</div>
          </div>`
        });
        this.timer = 300;
      } else {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('validate_otp_send_fail')}</div>
          </div>`
        });
      }
      this.loadingFinished = true;
    },
    inputField() {
      this.verifyFail = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.paddingCustom {
  padding: 30px 0 60px 0;

  @media screen and (max-width: 600px) {
    padding: 0px 0 30px 0;
  }
}
</style>
